import { Button } from "@inmagik/magik-ui"
import { Formik } from "formik"
import { useMemo } from "react"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import type { NamedEntity } from "../../types"
import { initialValuesNamedEntity, validationSchemaNamedEntity } from "./NamedEntityCommon"
import NamedEntityForm from "./NamedEntityForm"

export default function NamedEntityModal({
  title,
  namedEntity,
  save,
  show,
  onClose,
  type,
}: {
  title: string
  namedEntity?: NamedEntity
  save: (values: NamedEntity, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
  type: "AUTHOR" | "EDITOR" | "PHOTOGRAPHER" | "TYPOLOGY" | "FORMAT"
}) {
  const initialValues = useMemo(() => initialValuesNamedEntity(namedEntity, type) as NamedEntity, [namedEntity, type])
  const validationSchema = useMemo(() => validationSchemaNamedEntity(), [])

  return (
    <Formik enableReinitialize initialValues={initialValues} validationSchema={validationSchema} onSubmit={save}>
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <NamedEntityForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
